module.exports = __webpack_public_path__ + "media/images/emblems/Pfungen-blazon-b0a3499419d6d93ab8ab0b18559999f2.svg";